import axiosInstance from "../axiosInstance"
import type {
  LoginDto,
  LoginResponseDto,
  ForgotPasswordDto,
  ForgotPasswordResponseDto,
  ResetPasswordDto,
  ResetPasswordResponseDto,
  ChangePasswordDto,
  ChangePasswordResponseDto,
  UserResponseDto,
} from "../types/auth.types"

/**
 * Auth API Client
 * Direct API calls using axios instance
 */
export const authClient = {
  // Login
  login: (data: LoginDto): Promise<LoginResponseDto> => {
    return axiosInstance.post("/auth/login/admin", data)
  },

  // Forgot password
  forgotPassword: (data: ForgotPasswordDto): Promise<ForgotPasswordResponseDto> => {
    return axiosInstance.post("/auth/forgot-password", data)
  },

  // Reset password
  resetPassword: (data: ResetPasswordDto): Promise<ResetPasswordResponseDto> => {
    return axiosInstance.post("/auth/reset-password", data)
  },

  // Change password (for logged-in users)
  changePassword: (data: ChangePasswordDto): Promise<ChangePasswordResponseDto> => {
    return axiosInstance.post("/auth/change-password", data)
  },

  // Get current user
  me: (): Promise<UserResponseDto> => {
    return axiosInstance.get("/auth/me")
  },
}

